var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.28,18.89l.63-.63-1.69-1.69V14.06h-.89v2.87ZM4.35,19.2a1.32,1.32,0,0,1-1-.39,1.3,1.3,0,0,1-.39-1V4.37A1.35,1.35,0,0,1,4.35,3H17.83a1.35,1.35,0,0,1,1.35,1.35v7.39a3.89,3.89,0,0,0-.66-.29l-.69-.18V4.37H4.35V17.85h6.94c.06.24.13.48.2.7a6.32,6.32,0,0,0,.27.65Zm0-2.4v0ZM6.6,15.61h4.74a7.15,7.15,0,0,1,.2-.7,3.4,3.4,0,0,1,.29-.65H6.6Zm0-3.82h7.73a5,5,0,0,1,.6-.26c.2-.07.41-.13.65-.19v-.9h-9ZM6.6,8h9V6.62h-9ZM16.78,21a4.25,4.25,0,0,1-4.23-4.2,4.08,4.08,0,0,1,1.24-3,4.18,4.18,0,0,1,6,0,4.09,4.09,0,0,1,1.25,3A4.27,4.27,0,0,1,16.78,21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocTime);
export default __webpack_public_path__ + "static/media/icon-doc-time.f31b10c6d105d0938c5bbf9a80b71108.svg";
export { ForwardRef as ReactComponent };